import { getApi } from '../../../components/Shared/shared';
const baseURL = getApi();

export const purchasesUrls = {
  purchases: `${baseURL}/purchases`,
  outletPurchases: `${baseURL}/purchases/outlet`
};

export default purchasesUrls;
